export default function Cover({ title, subtitle }) {
  return (
    <div className="relative w-full min-h-[85vh] overflow-hidden p-0">
      <div className="absolute inset-0 z-10 flex items-center justify-center text-center px-0 bg-white/40">
        <div className="flex flex-col gap-3">
          <h1 className="font-semibold">{title}</h1>
          <h3 className="ppt-subtitle">{subtitle}</h3>
        </div>
      </div>
    </div>
  );
}
